import { get } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withComponentId } from '../../../../common/ComponentIdContext';
import { withComponentName } from '../../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../../common/sync-component/Const';
import {
  getDefaultSyncType,
  syncComponentSelector,
} from '../../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../../helpers/EventEmitter';
import { changeCode, REDUCER_NAME } from '../../reducer';
import { SearchFilter } from '../../../../common/search-filter';
import IndexSumary from './index-summary';
import './index.scss';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../../../app/commonReducer';

class SearchBox extends Component {
  componentDidMount() {
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, changeCode, componentId } = this.props;
    if (
      syncType === TYPE_DISABLE ||
      data.syncType !== syncType ||
      data.search.isIndex ||
      data.search.isDerivatives ||
      !data.search.isTicker ||
      componentId === data.componentId
    ) {
      return;
    }
    changeCode(data.search);
  };

  clickItemSearch = currentSearch => {
    const { changeCode, syncType, componentId } = this.props;

    changeCode(currentSearch);

    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      componentId,
      syncType: syncType,
      search: currentSearch,
    });
  };

  render() {
    const {
      currentSearch,
      indexSumary,
      indexSumaryRealTime,
      listOrganizationByOrganCode,
    } = this.props;

    const isRealTime =
      Object.keys(indexSumaryRealTime).length &&
      indexSumary.organCode === indexSumaryRealTime.organCode;
    const indexSumanyToProp = isRealTime ? indexSumaryRealTime : indexSumary;

    return (
      <div className="search-box-wrapper">
        <SearchFilter
          schema={[
            { key: 'displayCode', className: 'w-20' },
            { key: 'codeName', className: 'w-55 text-truncate' },
            {
              key: 'exchange',
              className: 'w-25 text-right',
              render: text => {
                return text.toUpperCase();
              },
            },
          ]}
          listKeyFilter={['displayCode', 'codeName']}
          getListSearchFromRedux={state =>
            state[COMMON_REDUCER_NAME].listOrganizationSearch
          }
          currentSearch={
            listOrganizationByOrganCode[currentSearch.code] || currentSearch
          }
          mainKey={'code'}
          sortKey={'displayCode'}
          clickItemSearch={this.clickItemSearch}
          customWidth={170}
        />
        <div className="left-info-widget__metas">
          <IndexSumary
            indexSumaryRealTime={indexSumanyToProp}
            isRealTime={isRealTime}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  changeCode,
};

const mapStateToProps = (state, { componentName, componentId }) => {
  return {
    currentSearch: state[REDUCER_NAME].currentSearch,
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    indexSumary: state[REDUCER_NAME].indexSumary,
    indexSumaryRealTime: state[REDUCER_NAME].indexSumaryRealTime,
    syncType: syncComponentSelector(state, componentName, componentId),
  };
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SearchBox);
